import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  ArrayMinSize,
  IsArray,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import {
  PhotoItemDto,
  PHOTO_BATCH_MAX_ITEMS,
} from '../../job-repair-photo/dto/job-repair-photo-item.dto';

/** Body of POST /job-phase-bump-photo/batch. Returns the full photo list of the bump. */
export class JobPhaseBumpPhotoBatchDto {
  @ApiProperty({ format: 'uuid' })
  @Expose()
  @IsUUID('4')
  jobPhaseBumpId!: string;

  @ApiProperty({ type: () => [PhotoItemDto] })
  @Expose()
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(PHOTO_BATCH_MAX_ITEMS)
  @ValidateNested({ each: true })
  @Type(() => PhotoItemDto)
  photos!: PhotoItemDto[];
}
